import React from 'react'
import Combo_course from '../Component/Combo_course'
import Combo_course_mobile from '../Component/Combo_course_mobile'
import { PiArrowCircleRightThin } from 'react-icons/pi'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import Total_Count from '../Component/Total_Count'
import Counsellor from '../Component/Counsellor'

function Combo_page() {
  const benefits = [
    'Industrial Experts/Mentors',
    'Tailored Curriculum',
    'Continuous Innovation',
    'Interactive Learning Tools',
    'Dedicated Support team',
    'Lifetime Access',
    'Industrial Projects',
    'Hands on Experience',
  ]

  const programs = [
    'Artificial Intelligence',
    'Machine Learning',
    'Web Development',
    'Data Science',
    'Android App Development',
    'Robotics',
    'Cyber Security',
    'Cloud Computing',
    'Human Resource',
    'Finance',
    'Business Analytics',
    'AutoCAD',
    'Digital Marketing',
    'VLSI',
    'Internet of Things',
    'Embedded System',
  ]

  return (

    <>
    <div>
    {/* -----------------------Mobile View------------------------ */}
    <div className='Combo_background_image d-sm-block d-md-none mt-5'>
        <div className='container-fluid Combo_background_color pt-5'>
            <div className='text-center Combo_Main_text py-5'>
                <h1 className='display-2 text-white'>Combo Program</h1>
                <h3 className='text-white fs-5 pt-1'>We're more than a story; we're a journey</h3>
            </div>
        </div>
    </div>

    {/* -------------------Desktop View------------------------- */}
    <div className='Combo_background_image d-none d-md-block mt-5'>
        <div className='container-fluid Combo_background_color py-5'>
            <div className='text-center pt-5 Combo_Main_text mt-5'>
                <h1 className='display-3 pt-5 text-white'>Combo Program</h1>
                <h3 className='text-white fs-2 pt-2 pb-5 mb-5'>We're more than a story; we're a journey</h3>
            </div>
        </div>
    </div>
    </div>

    <div className="mt-2">
      <div className="container">
        <div className="container">
          <div className="d-none d-md-block px-3 py-5">
            <Combo_course />
          </div>
          <div className="d-sm-block d-md-none">
            <Combo_course_mobile />
          </div>
{/* -------------------------Desktop View----------------------------- */}
          <div className='d-none d-md-block'>
            <div className="container combo_box_text">
              <div className="row">
                <div className="col-md-8  border rounded px-5 pt-5">
                  <div>
                    <div className="border-bottom pb-3">
                      <h1 className="fs-6 fw-bold">
                        Couldn't find your preferred courses?
                      </h1>
                      <h2 className="fs-1">Customise Your Own</h2>
                    </div>
                    <div className="row mt-4">
                      {benefits.map((benefit, index) => (
                        <div className='col-md-6' key={index}>
                          <div className='row'>
                            <div className='col-1'>
                              <PiArrowCircleRightThin size="20px" color="#2b1c50" />
                            </div>
                            <div className='col-11'>
                              <p>{benefit}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="">
                    <div className="Program_details_form px-4">
                      <div className="py-4">
                        <form>
                          <div className="mt-2">
                          <label for="fullName" class="pb-2 contact_form"><SlUser size="18px"/>{' '}Full Name</label>
                            <input
                              className="form-control"
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Full Name"
                              required
                            />
                          </div>
                          <div className="mt-3">
                          <label for="email" class="pb-2 contact_form"><MdOutlineMailOutline size="18px"/>{' '}Email Address</label>
                            <input
                              className="form-control"
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Email Address"
                              required
                            />
                          </div>
                          <div className="mt-3">
                          <label for="mobileNo" class="pb-2 contact_form"><HiOutlinePhone size="18px"/>{' '}Phone Number</label>
                            <input
                              className="form-control"
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              required
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="Program1" className="pb-2 contact_form">
                              Program 1
                            </label>
                            <select
                              className="form-control"
                              id="Program1"
                              name="Program1"
                              required
                            >
                              <option value="">Select a Program...</option>
                              {programs.map((program, index) => (
                                <option value={program} key={index}>{program}</option>
                              ))}
                            </select>
                          </div>
                          <div className="mt-3">
                            <label htmlFor="Program2" className="pb-2 contact_form">
                              Program 2
                            </label>
                            <select
                              className="form-control"
                              id="Program2"
                              name="Program2"
                              required
                            >
                              <option value="">Select a Program...</option>
                              {programs.map((program, index) => (
                                <option value={program} key={index}>{program}</option>
                              ))}
                            </select>
                          </div>

                          <div className="row mt-2 pt-4">
                            <div className="d-flex justify-content-center">
                              <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/* --------------------------Mobile View----------------------------- */}
          <div className='d-sm-block d-md-none mt-5'>
            <div className="container border rounded py-3 combo_box_text">
              <div className="row">
                <div className="col-md-8">
                  <div>
                    <div className="border-bottom pb-3">
                      <h1 className="fw-bold">
                        Couldn't find your preferred courses?
                      </h1>
                      <h2 className="fs-1">Customise Your Own</h2>
                    </div>
                    <div className="row my-4">
                      {benefits.map((benefit, index) => (
                        <div className='col-md-6' key={index}>
                          <div className='row'>
                            <div className='col-1'>
                              <PiArrowCircleRightThin size="20px" color="#2b1c50" />
                            </div>
                            <div className='col-11'>
                              <p>{benefit}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="">
                    <div className="Program_details_form px-4">
                      <div className="py-4">
                        <form>
                          <div className="mt-2">
                          <label for="fullName" class="pb-2 contact_form"><SlUser size="18px"/>{' '}Full Name</label>
                            <input
                              className="form-control"
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Full Name"
                              required
                            />
                          </div>
                          <div className="mt-3">
                          <label for="email" class="pb-2 contact_form"><MdOutlineMailOutline size="18px"/>{' '}Email Address</label>
                            <input
                              className="form-control"
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Email Address"
                              required
                            />
                          </div>
                          <div className="mt-3">
                          <label for="mobileNo" class="pb-2 contact_form"><HiOutlinePhone size="18px"/>{' '}Phone Number</label>
                            <input
                              className="form-control"
                              type="tel"
                              id="mobileNo"
                              name="mobileNo"
                              placeholder="+91 xxxxxxxxxx"
                              required
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="Program1" className="pb-2 contact_form">
                              Program 1
                            </label>
                            <select
                              className="form-control"
                              id="Program1"
                              name="Program1"
                              required
                            >
                              <option value="">Select a Program...</option>
                              {programs.map((program, index) => (
                                <option value={program} key={index}>{program}</option>
                              ))}
                            </select>
                          </div>
                          <div className="mt-3">
                            <label htmlFor="Program2" className="pb-2 contact_form">
                              Program 2
                            </label>
                            <select
                              className="form-control"
                              id="Program2"
                              name="Program2"
                              required
                            >
                              <option value="">Select a Program...</option>
                              {programs.map((program, index) => (
                                <option value={program} key={index}>{program}</option>
                              ))}
                            </select>
                          </div>

                          <div className="row mt-2 pt-4">
                            <div className="d-flex justify-content-center">
                              <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Total_Count/>
      <div className='mt-5'>
      <Counsellor/>
      </div>
    </div>
    </>
  )
}

export default Combo_page
